import { createRouter, createWebHistory } from 'vue-router'
import { handleHotUpdate, routes } from 'vue-router/auto-routes'
import { IDENT_STEPS, StepId } from '@/types'
import { useEmbed } from '@/composables/use-embed.ts'
import { useUserSession } from '@/composables/use-user-session.ts'
import type { Router } from 'vue-router'

const validStepIds = new Set(IDENT_STEPS.map((step) => step.id))

export const getRouter = (): Router => {
  // reads the embed origin from the landing URL before any navigation rewrites it
  useEmbed()

  const router = createRouter({
    history: createWebHistory(),
    routes,
  })

  const { isAuthenticated } = useUserSession()

  // This will update routes at runtime when creating new pages without reloading the page
  if (import.meta.hot) {
    handleHotUpdate(router)
  }

  router.beforeEach((to) => {
    if (to.meta.requiresAuth && !isAuthenticated.value) {
      return {
        name: 'flow',
        params: { stepId: 'login' },
        query: { redirect: to.fullPath },
      }
    }

    if (to.name === 'flow') {
      const stepId = to.params.stepId as StepId

      // add route guard to prevent invalid stepId
      // absolute path: a relative '404' resolves to /flow/404, which hits this guard again
      if (!validStepIds.has(stepId)) {
        return { path: '/404' }
      }
    }

    return true
  })

  console.log('ROUTER: router initialized')

  return router
}
